import { Avatar, Clickable, Col, Row, Text } from 'components';
import { theme } from 'lib';

const SuggestionItem = ({ item, onClick }) => {
  return (
    <Clickable onClick={() => onClick(item)}>
      <Row start center pad="0 16px">
        <Avatar user={item} small />

        <Col marg="0 0 0 8px" center>
          <Text b2 bold>
            {item.name}
          </Text>
          <Text c1 col={theme.GREY_60}>
            @{item.username}
          </Text>
        </Col>
      </Row>
    </Clickable>
  );
};

export default SuggestionItem;
